import "./LandingPage.scss";

import { faShare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { Fragment, useState, useEffect, useRef } from 'react';
import Brand from "../../components/Brand";
import { useCurrentUser } from '../../UserProvider';
import { api, setAuthToken } from '../../utils/api';

export default function LandingPage() {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { currentUser, refreshUser } = useCurrentUser();
  const skipAutoRedirectRef = useRef(false);

  const handleSendMessage = () => {
    if (!message.trim()) return;
    handlePresetClick(message);
  };

  useEffect(() => {
    if (currentUser && !skipAutoRedirectRef.current) {
      navigate('/home', { replace: true });
    }
  }, [currentUser, navigate]);

  const handlePresetClick = async (presetMessage) => {
    try {
      // tell the redirect effect to chill
      skipAutoRedirectRef.current = true;

      const { data } = await api.post('/users', { registered: false });
      setAuthToken(data);
      await refreshUser();

      navigate(`/chat?message=${encodeURIComponent(presetMessage)}`);
    } catch (err) {
      console.error('Failed to create guest user', err);
      navigate(`/chat?message=${encodeURIComponent(presetMessage)}`);
    }
  };

  return (
    <Fragment>
      <div className='__landing'>
        <section className='banner'>
          <div className='banner__container container'>
            <div className='banner__content content'>
              <Brand.Logo height={125} className="banner__content__logo" />

              <h1 className='content__title'>
                Ask. Apply. Get Booked
              </h1>

              <div className='content__chat'>
                <div className='chat-buttons'>
                  <button
                    type="button"
                    className='ppy-btn ppy-btn-primary'
                    onClick={() => handlePresetClick('Find gigs for drummers')}
                  >
                    Find gigs for drummers
                  </button>
                  <button
                    type="button"
                    className='ppy-btn ppy-btn-primary'
                    onClick={() => handlePresetClick('Find gigs in SoCal')}
                  >
                    Find gigs in SoCal
                  </button>

                  <button
                    type="button"
                    className='ppy-btn ppy-btn-primary'
                    onClick={() => handlePresetClick('What gigs pay $200+?')}
                  >
                    What gigs pay $200+?
                  </button>
                </div>

                <div className='chat'>
                  <input
                    type="text"
                    placeholder="Are there any gigs close to me?"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    }}
                  />
                  <button className='ppy-btn ppy-btn-primary' onClick={handleSendMessage}>
                    <FontAwesomeIcon icon={faShare} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='section section--primary'>
          <h3 className='section__title title title--center container'>
            Cut through the noise.<br />
            No endless threads.<br />
            Just gigs you can apply to today.<br />
          </h3>
        </section>

        <section className='section section--transparent'>
          <div className='section__grid grid container'>
            <div className='grid__column column column--middle'>
              <h3 className='section__title title'>
                Dynamic gig board for <br /> working musicians.
              </h3>
              <p className='section__description description description--large'>
                Filter by genre, location, and <br /> budget — no endless scrolling.
              </p>
            </div>
            <div className='grid__column'>
              <div className='image image-002' />
            </div>
          </div>
        </section>

        <section className='section section--primary'>
          <div className='section__grid grid container'>
            <div className='grid__column'>
              <div className='image image-003' />
            </div>
            <div className='grid__column column column--middle'>
              <h3 className='section__title title'>
                Every artist on Papaya <br /> builds a real profile
              </h3>
              <p className='section__description description description--small'>
                Papaya is built by musicians, for musicians. Profiles highlight verified skills and performance history, and gigs are community-sourced from trusted industry spaces.
              </p>
              <Link to='/jobs' className='section__button--end button button--large button--black'>
                Get Started <FontAwesomeIcon icon={faShare} />
              </Link>
            </div>
          </div>
        </section>

        <section className='section section--transparent section--brand-right'>
          <div className='section__grid grid container'>
            <div className='grid__column'>
              <div className='section__image--image-004 image image-004' />
            </div>
            <div className='grid__column column column--middle'>
              <h3 className='section__title title'>
                Your art in one page.
              </h3>
              <p className='section__description description description--large'>
                Connect all your social and music platforms and promote your tracks, playlists and upcoming events.
              </p>
            </div>
          </div>
        </section>
      </div>
    </Fragment>
  );
}